import { Box, Paper } from "@mui/material";
import HorizontalStepper from "../stepper/horizontal-stepper";
import SelectClientStep from "./steps/select-client-step";
import SelectEntityStep from "./steps/select-entity-step";
import SelectFieldStep from "./steps/select-field-step";
import CleansingData from "./steps/cleansing-data-step";
import { LAYOUT } from "./constants";
import useClientSelection from "./hooks/use-client-selection";

const StepperContent = () => {
  const { clients, isLoading } = useClientSelection();
  const hasData = !isLoading && clients.length > 0;

  return (
    <Box data-testid="stepper-content">
      {hasData && (
        <HorizontalStepper showLabels allowStepClick alternativeLabel={false} />
      )}
      <Paper
        sx={{
          p: LAYOUT.PAPER_PADDING,
          mt: hasData ? LAYOUT.PAPER_MARGIN_TOP : 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: LAYOUT.MAIN_GAP,
          }}
          data-testid="step-content-container"
        >
          <SelectClientStep />

          {hasData && (
            <Box
              sx={{ display: "flex", gap: LAYOUT.CONTENT_GAP, minHeight: 764 }}
              data-testid="multi-column-layout"
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: LAYOUT.CONTENT_GAP,
                  width: LAYOUT.SIDEBAR_WIDTH,
                }}
                data-testid="sidebar-column"
              >
                <Box sx={{ flex: 1 }}>
                  <SelectEntityStep />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <SelectFieldStep />
                </Box>
              </Box>

              <Box sx={{ flex: 1 }} data-testid="main-column">
                <CleansingData />
              </Box>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default StepperContent;
